import { InputNumber } from 'antd';

InputNumber.__hasLoad = true;

export default InputNumber;
